var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKpdiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 54,
    viewBox: "0 0 162 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.548 0.36084H149.015V53.3847H161.548V0.36084ZM105.098 12.2455H93.2489V22.909H103.804C114.31 22.909 124.151 31.1304 124.151 43.3822V53.6391H136.33V43.3826C136.33 26.9491 123.096 12.2455 105.098 12.2455ZM84.7414 2.97214C84.7414 2.16998 84.6942 1.36646 84.6469 0.36084H71.7979C71.95 1.36691 71.8976 2.16998 71.8976 2.97214C71.8976 15.7737 61.5248 24.359 50.4409 24.359H39.3108V35.5064H51.8052C70.7913 35.5064 84.7414 20.1426 84.7414 2.97214ZM32.8981 53.4697L11.7738 26.6512L32.1445 0.36084H16.7162L0 21.5518V32.6003L16.716 53.4697H32.8981Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpdiLogo);
export default __webpack_public_path__ + "static/media/KPDILogo.72fd748c0c5798ed3f8008564796781c.svg";
export { ForwardRef as ReactComponent };